import { Check, X } from 'lucide-react';
import { evaluatePassword } from '../utils/passwordPolicy';

interface PasswordRequirementsProps {
  password: string;
}

export default function PasswordRequirements({ password }: PasswordRequirementsProps) {
  return (
    <ul
      aria-label="Password requirements"
      className="mt-2 grid gap-1 text-xs text-muted-foreground"
    >
      {evaluatePassword(password).map(({ id, label, met }) => (
        <li
          key={id}
          className={met ? 'flex items-center gap-1.5 text-emerald-400' : 'flex items-center gap-1.5'}
        >
          {met
            ? <Check aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />
            : <X aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />}
          <span>{label} — {met ? 'met' : 'not met'}</span>
        </li>
      ))}
    </ul>
  );
}
